import type { LandingPageContent } from '../types'

export const PRESUPUESTO_FOTOVOLTAICO_SIN_TELEFONO: LandingPageContent = {
  slug: 'presupuesto-fotovoltaico-sin-telefono',
  lang: 'es',
  topicId: 'photovoltaik-ohne-telefonnummer',
  title: 'Presupuestos fotovoltaicos sin teléfono – 100% anónimo',
  metaDescription:
    'Solicite presupuestos fotovoltaicos sin dar su número de teléfono ni correo: solicitud ' +
    'anónima, sin llamadas comerciales, contacto solo tras su autorización. Gratis.',
  keywords: [
    'fotovoltaica sin teléfono',
    'presupuesto fotovoltaico sin correo',
    'solicitud fotovoltaica anónima',
    'comparar ofertas solares sin llamadas',
    'fotovoltaica sin registro',
    'librarse de comerciales fotovoltaica',
    'evitar venta a domicilio fotovoltaica',
  ],
  eyebrow: 'Anónimo y sin llamadas comerciales',
  h1: 'Presupuestos fotovoltaicos sin dar su número de teléfono ni correo electrónico',
  intro:
    'En la mayoría de los portales comparativos, el teléfono o el correo electrónico son ' +
    'obligatorios antes de ver ningún presupuesto - y esos mismos datos se reparten después entre ' +
    'varias empresas a la vez. En Roofora toda la solicitud funciona sin ninguno de los dos: ' +
    'compara presupuestos fotovoltaicos sin que ninguna empresa pueda llamarle antes de que usted ' +
    'lo autorice expresamente.',
  sections: [
    { type: 'heading', text: 'Por qué el teléfono y el correo son un problema en otros portales' },
    {
      type: 'paragraph',
      text:
        'En cuanto una solicitud con datos de contacto reales se publica, usted deja de decidir ' +
        'quién la ve. Muchos portales venden la misma solicitud a varias empresas a la vez - el ' +
        'resultado son llamadas de comerciales con los que nunca ha hablado, a veces pocos minutos ' +
        'después de enviarla.',
    },
    { type: 'heading', text: 'Así funciona la solicitud completamente anónima en Roofora' },
    {
      type: 'paragraph',
      text:
        'Su cuenta se crea solo con un nombre de usuario y una contraseña elegidos por usted, más ' +
        'un código de recuperación para restablecerla - sin correo electrónico, sin teléfono. Su ' +
        'solicitud (fotos del tejado, foto del cuadro eléctrico, orientación, consumo) se publica ' +
        'de forma anonimizada: las empresas ven la zona y los datos técnicos, pero no sus datos ' +
        'de contacto.',
    },
    { type: 'heading', text: 'Cuándo puede una empresa instaladora contactarle' },
    {
      type: 'paragraph',
      text:
        'Las empresas pueden presentar un presupuesto sin compromiso o enviar una solicitud de ' +
        'contacto - ambas cosas le llegan solo como notificación anónima. Solo cuando usted ' +
        'autoriza activamente a una empresa concreta, esa empresa recibe su teléfono y correo ' +
        'electrónico. Sin autorización colectiva, sin automatismos.',
    },
    {
      type: 'list',
      items: [
        'Ninguna llamada posible al registrarse o al recibir un presupuesto',
        'Sus datos no se revenden a terceros',
        'Usted fija un límite de cuántas empresas pueden recibir sus datos de contacto',
        'Cada autorización es válida solo para una empresa elegida por usted',
        'Compare presupuestos con calma, sin la presión de las llamadas',
      ],
    },
    { type: 'heading', text: 'Para quién es especialmente útil la solicitud anónima' },
    {
      type: 'paragraph',
      text:
        'Si alguna vez, tras pedir un solo presupuesto, le llamaron varias empresas distintas ' +
        'durante días, ya conoce el problema. La solicitud anónima lo evita: sigue siendo ' +
        'inalcanzable para las llamadas comerciales hasta que usted mismo da el primer paso.',
    },
  ],
  faq: [
    {
      q: '¿De verdad no tengo que dar mi número de teléfono?',
      a: 'No. Para la cuenta de cliente no hace falta ni teléfono ni correo electrónico - se registra solo con nombre de usuario y contraseña.',
    },
    {
      q: '¿Cómo me registro entonces o restablezco mi contraseña?',
      a: 'Al registrarse recibe un código de recuperación con el que puede restablecer su contraseña más adelante - sin buzón de correo ni SMS.',
    },
    {
      q: '¿Y si sí quiero que me contacte una empresa en concreto?',
      a: 'Puede autorizar en cualquier momento a una empresa concreta - solo entonces esa empresa recibe su teléfono y correo electrónico, las demás siguen sin acceso.',
    },
    {
      q: '¿Cómo me libro de las llamadas comerciales de otros proveedores de fotovoltaica?',
      a: 'En Roofora el problema no llega a existir: sus datos de contacto solo se comparten con las empresas que usted autorice individualmente. Si ya recibe llamadas no deseadas de otros proveedores, lo más seguro es no dar datos sensibles por teléfono y colgar si tiene dudas.',
    },
    {
      q: '¿Cómo evito la venta a domicilio en fotovoltaica?',
      a: 'La forma más segura es solicitar presupuestos desde el principio mediante una solicitud anónima, en lugar de a través de comerciales en la puerta de casa o por teléfono - así decide usted solo qué empresa puede contactarle.',
    },
  ],
  primaryCta: { label: 'Solicitar presupuesto anónimo ahora', action: 'customer' },
  secondaryCta: {
    label: 'Cómo funciona la comparación de presupuestos',
    action: 'link',
    href: '/comparar-presupuestos-fotovoltaicos',
  },
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: '¿Cuánto cuesta una instalación fotovoltaica?', href: '/coste-instalacion-fotovoltaica' },
    { label: 'Solicitar presupuesto fotovoltaico paso a paso', href: '/solicitar-presupuesto-fotovoltaico' },
  ],
}
